import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/default.config'
import { VueAxios } from '@/utils/request'
import store from '@/store'
import router from '@/router'

// base library
import Antdv, { Modal, message, notification } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import VTooltip from 'v-tooltip'
import Shence from '@eccang/shence_sdk'
// ext library
import Dialog from '@/components/Modal'
import IconFont from '@/components/IconFont'
import './filters/menuLocalName'
// xe-utils
import XEUtils from 'xe-utils/ctor'
import merge from 'xe-utils/merge'
import 'intersection-observer'
IntersectionObserver.prototype.POLL_INTERVAL = 100

XEUtils.mixin({
  merge
})

Vue.use(Antdv)
Vue.use(VueStorage, config.storageOptions)
Vue.use(VueAxios)
Vue.use(IconFont)
Vue.use(VTooltip)
Vue.use(Shence, {
  appCode: 'USERCENTER',
  appName: '用户中心',
  isProduction: process.env.NODE_ENV === 'production', // 是否生产环境(生产环境和测试环境推送的目标地址不一样)
  showLog: process.env.NODE_ENV === 'production_xx', // 是否打印日志
  isBase: true, // 区分用户中心基座，子系统传false或不传
  classPrefix: [
    'home-',
    'entry-layout-header',
    'entry-multi-tab'
  ] // 父应用模块的类名前缀，用于界定当前点击的节点为父应用还是子应用
})

Vue.prototype.$dialog = {
  iframe: Dialog.iframe
}

const prefixCls = 'home-ant'
// Message
message.config({
  prefixCls: `${prefixCls}-message`,
  maxCount: 3
})
Vue.prototype.$message = message

// Notification
Vue.prototype.$notification = {
  close: (key) => notification.close(key)
}
for (let type of ['success', 'error', 'info', 'warning', 'warn', 'open']) {
  Vue.prototype.$notification[type] = (params) => notification[type]({
    prefixCls: `${prefixCls}-notification`,
    ...params
  })
}
// Modal
for (let type of ['confirm', 'info', 'success', 'error', 'warning']) {
  Vue.prototype['$' + type] = (params) => {
    if (typeof params === 'string') {
      params = {
        content: params
      }
    }
    const defaultConfig = {
      prefixCls: `${prefixCls}-modal`,
      okButtonProps: {
        props: {
          prefixCls: `${prefixCls}-btn`
        }
      },
      cancelButtonProps: {
        props: {
          prefixCls: `${prefixCls}-btn`
        }
      }
    }
    return Modal[type](XEUtils.merge({}, defaultConfig, params))
  }
}

function demoAddMethod (el, binding, vNode) {
  const vm = vNode.context // 绑定this
  const { $store, $message } = vm
  const { value, arg } = binding
  el.onclick = function (e) {
    if ($store.getters.isDemo) {
      $message.warning(vm.$t('layouts.demo.tips'))
    } else {
      vm[value].apply(vm, arg && (arg instanceof Array ? arg : [arg]))
    }
    e.preventDefault()
    e.stopPropagation()
  }
}

Vue.directive('demo', {
  bind: demoAddMethod,
  componentUpdated: demoAddMethod
})

Vue.filter('menuNameRender', function (pane) {
  let lang = store.getters.currentLang
  let menuName = pane?.menuName?.[lang] || pane.tab
  if (typeof pane.menuName === 'string') {
    const langCodes = {
      'zh_CN': 'menuName',
      'en_US': 'menuEnName',
      'ko_KR': 'menuKrName'
    }
    menuName = pane[langCodes[lang]]
  }
  return menuName
})

// 首字母大写
const ucstr = (text, space = true) => text.toLocaleLowerCase().replace(new RegExp('(' + (space ? ' |^' : '^') + ')[a-z]', 'g'), (L) => L.toUpperCase())
Vue.directive('ucstr', {
  inserted (el, binding) {
    el.innerText = ucstr(binding.value)
  }
})
Vue.filter('ucstr', (...value) => ucstr.apply(this, value))
Vue.prototype.$ucstr = ucstr

// 单位
Vue.prototype.$ucUnit = function (path, count) {
  if (path && /^measure_/.test(path)) {
    return this.$tc(path, count, { count })
  }
  return `${(count || '')}${(path || '')}`
}

Vue.prototype.$winOpen = (path, name) => {
  const url = window.location.origin + `${process.env.SSO_ENV ? `/${process.env.SSO_ENV}` : ''}${path.replace(/^(\/?)/, '/')}`
  console.log('url', url)
  window.open(url, name)
}

Vue.prototype.$query = () => {
  const calcQuery = (hash) => {
    const str = hash.split('?')
    if (str.length !== 2) return {}
    return str[1].split('&').reduce((acc, cur) => {
      const [key, value] = cur.split('=')
      return {
        ...acc,
        [key]: `${value}`
      }
    }, {})
  }
  const route = router.currentRoute
  return Object.keys(route?.query || {}).length ? route.query : calcQuery(route.hash)
}
